import { render, staticRenderFns } from "./navbar-support.vue?vue&type=template&id=640a7319&"
import script from "./navbar-support.vue?vue&type=script&lang=ts&"
export * from "./navbar-support.vue?vue&type=script&lang=ts&"
import style0 from "./navbar-support.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports